import { connect } from 'react-redux';
import { appNamedRoutes } from 'routes';
import { getQueryFromState } from 'utils/query';
import AccountHeader from 'components/account/AccountHeader';

const mapStateToProps = (state) => {
  return {
    backLink: { pathname: appNamedRoutes.accounts, search: getQueryFromState(state.meta.accounts, 'accounts')},
  }
}

const AccountHeaderContainer = connect(
  mapStateToProps,
  null
)(AccountHeader)

export default AccountHeaderContainer;
